"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TSEnumMemberDefinition = void 0;
const DefinitionBase_1 = require("./DefinitionBase");
const DefinitionType_1 = require("./DefinitionType");
class TSEnumMemberDefinition extends DefinitionBase_1.DefinitionBase {
    constructor(name, node) {
        super(DefinitionType_1.DefinitionType.TSEnumMember, name, node, null);
    }
    isTypeDefinition = true;
    isVariableDefinition = true;
}
exports.TSEnumMemberDefinition = TSEnumMemberDefinition;
//# sourceMappingURL=TSEnumMemberDefinition.js.map